/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import { useState, useEffect } from "react";
import Chart from "chart.js";
import { Line, Bar } from "react-chartjs-2";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
} from "reactstrap";

// core components
import {
    chartOptions,
    parseOptions,
    chartExample2,
} from "variables/charts.js";
import { reportAppUsage } from "../../../../network/ApiAxios.js";
import secureLocalStorage from "react-secure-storage";

const UsageChart = (props) => {
    const [isLoading, setisLoading] = useState(false)
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const app = JSON.parse(secureLocalStorage.getItem("app"));

    if (window.Chart) {
        parseOptions(Chart, chartOptions());
    }

    let prepareData = (metrics) => {
        
        let today = new Date()
        let dataset = new Array(12)
        for(let i=0; i<12; i++) dataset[i] = 0 //inicializando dataset
        let labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

        metrics.map((metric => {
            let date = new Date(metric.date)
            let month = date.getMonth()
            
            //apenas dados dentro do ano corrente
            if(today.getFullYear() == date.getFullYear())
                dataset[month] = dataset[month] + 1
        }))

        chartExample2.data.datasets[0].data = dataset
        chartExample2.data.datasets[0].label = "Accesss"
        chartExample2.data.labels = labels                
        
    }

    useEffect(() => {
        const runAsync = async () => {
            setisLoading(true);

            let params = {
                filter: { account: user.account, action: "login" },
                constraint: { app: app._id }
            }

            const response = await reportAppUsage(params);
            const { data } = response;

            if (data.success) {

                prepareData(data.report)

            }

            setisLoading(false);
        }

        runAsync();

    }, []);

    return (
        <Row>
            <Col xl="12">
                <Card className="shadow">
                    <CardHeader className="bg-transparent">
                        <Row className="align-items-center">
                            <div className="col">
                                <h6 className="text-uppercase text-muted ls-1 mb-1">
                                    App Usage
                                </h6>
                                <h2 className="mb-0">Total Accesses</h2>
                            </div>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {/* Chart */}
                        <div className="chart">
                            <Bar
                                data={chartExample2.data}
                                options={chartExample2.options}
                            />
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}


export default UsageChart;